export default __webpack_public_path__ + "static/media/6 AIRPORT SHUTTLES.e8a43259.png";